import { UserWithMetadata } from 'Services/apiResponseTypes'

export type GridColumnKind = 'readonly' | 'userField' | 'metadata'

export type CellChange = {
  userId: number
  kind: GridColumnKind
  field: string
  newValue: string | null
}

export const changeKey = (userId: number, kind: GridColumnKind, field: string): string =>
  `${userId}-${kind}-${field}`

export const originalValueFor = (
  user: UserWithMetadata,
  kind: GridColumnKind,
  field: string
): string | null =>
  kind === 'metadata'
    ? user.metadata[field] || null
    : (user[field as keyof UserWithMetadata] as string) || null
